import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './Footer.module.scss'
import { config } from '@percent/cause-dashboard/config'
import { Spacer, Typography } from '@percent/lemonade'

type FooterProps = {
  noTermsAndPrivacyPolicy?: boolean
  spread?: boolean
}

export function Footer({ noTermsAndPrivacyPolicy = false, spread = false }: Readonly<FooterProps>) {
  const { t } = useTranslation()

  const copyright = (
    <Typography variant="default" className={styles.footerText}>
      {t('typography.goodstack')}&nbsp;<span role="img">©</span>&nbsp;{new Date().getFullYear()}
    </Typography>
  )

  const legalLink = !noTermsAndPrivacyPolicy && (
    <a target="_blank" rel="noreferrer" href={config.urls.terms}>
      {t('typography.termsOfUse')}
    </a>
  )

  if (spread) {
    return (
      <footer className={`${styles.footerContainer} ${styles.footerSpread}`}>
        {copyright}
        {legalLink && (
          <Typography variant="default" className={`${styles.footerText} ${styles.legal}`}>
            {legalLink}
          </Typography>
        )}
      </footer>
    )
  }

  return (
    <footer className={styles.footerContainer}>
      <Typography variant="default" className={styles.footerText}>
        {t('typography.goodstack')}&nbsp;<span role="img">©</span>&nbsp;{new Date().getFullYear()}
        <Spacer size={4} axis="horizontal" />
        <span className={styles.dot}></span>
        <Spacer size={4} axis="horizontal" />
        {legalLink && <span className={styles.legal}>{legalLink}</span>}
      </Typography>
    </footer>
  )
}
